module.exports = __webpack_public_path__ + "static/media/34.4bee8dde.mp3";